import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../lib/api';

interface HubSpotFormProps {
  className?: string;
  onSuccess?: () => void;
  redirectToThankYou?: boolean;
  formType?: string;
}

export default function HubSpotForm({
  className = '',
  onSuccess,
  redirectToThankYou = true,
  formType = 'register_interest'
}: HubSpotFormProps) {
  const navigate = useNavigate();
  const submittedRef = useRef(false);
  const capturedFieldsRef = useRef<Record<string, any>>({});

  useEffect(() => {
    const scriptSrc = 'https://js-eu1.hsforms.net/forms/embed/147855768.js';
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.data?.type !== 'hsFormCallback') return;

      // Capture field data from payload if present
      const rawData = event.data?.data;
      if (Array.isArray(rawData)) {
        rawData.forEach((item: any) => {
          if (item?.name) capturedFieldsRef.current[item.name] = item.value;
        });
      } else if (rawData && typeof rawData === 'object') {
        if (rawData.submissionValues && typeof rawData.submissionValues === 'object') {
          Object.assign(capturedFieldsRef.current, rawData.submissionValues);
        } else {
          Object.assign(capturedFieldsRef.current, rawData);
        }
      }

      // Handle submission event
      if (
        (event.data?.eventName === 'onFormSubmitted' || event.data?.eventName === 'onFormSubmit') &&
        !submittedRef.current
      ) {
        submittedRef.current = true;

        const f = capturedFieldsRef.current;
        const email = f.email || f.Email || '';
        const firstName = f.firstname || f.first_name || '';
        const lastName = f.lastname || f.last_name || '';
        const fullName = (firstName || lastName)
          ? `${firstName} ${lastName}`.trim()
          : (f.name || 'HubSpot Form Lead');
        const mobile = f.phone || f.mobile || f.mobilephone || f.phone_number || '';
        const message = f.message || f.notes || '';
        const unitType = f.unit_type || f.unit || null;

        // Save to local database so it shows in Admin Panel -> Form Submissions
        try {
          await api.post('/forms', {
            form_type: formType,
            name: fullName,
            email: email || 'lead@hubspot-form.com',
            mobile: mobile,
            message: message,
            unit_type: unitType,
            subject: window.location.pathname
          });
        } catch (err) {
          console.error('Failed to sync HubSpot submission to local database:', err);
        }

        if (onSuccess) {
          try {
            onSuccess();
          } catch (err) {
            console.error('onSuccess error:', err);
          }
        }

        if (redirectToThankYou) {
          setTimeout(() => {
            navigate('/thank-you');
          }, 600);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onSuccess, redirectToThankYou, navigate, formType]);

  return (
    <div className={`hubspot-form-wrapper w-full min-h-[350px] ${className}`}>
      <div
        className="hs-form-frame"
        data-region="eu1"
        data-form-id="49087e52-a00a-4569-a9c1-0265a30255a1"
        data-portal-id="147855768"
      ></div>
    </div>
  );
}
